import { useEffect, useMemo, useState } from 'react';
import { useGetRepairFactoryList } from '../api/useGetRepairFactoryList';
import { usePickerSheet } from '../usePickerSheet';

interface PlantInfoStateHookProps {
  plantName: string;
  affiliateID: number;
}
export const usePlantInfoState = ({
  plantName,
  affiliateID,
}: PlantInfoStateHookProps) => {
  //type Definition
  type PlantInfoType = {
    id: number;
    name: string;
    address: string;
    phone: string;
  };
  type PlantResponseType = {
    id: number;
    plant_name: string;
    zip_code1: string;
    zip_code2: string;
    address1: string;
    address2: string;
    address3: string;
    phone_no: string;
    fax_no: string;
  }[];

  // Plant Select State
  const [plantItemList, setPlantItemList] = useState<PlantResponseType>([]);
  const [selectPlant, setSelectPlant] = useState<PlantInfoType>(
    {} as PlantInfoType,
  );

  const { repairFactoryList } = useGetRepairFactoryList({
    m_affiliate_id: affiliateID,
  });
  useEffect(() => {
    setPlantItemList((prev) =>
      Array.isArray(repairFactoryList?.plants)
        ? repairFactoryList?.plants
        : prev,
    );
  }, [repairFactoryList]);

  // Picker
  const plantNameList = useMemo(
    () => plantItemList.map((plant) => plant.plant_name),
    [plantItemList],
  );
  const { pickerSelect, pickerInputID } = usePickerSheet({
    initialSelect: plantName,
    selectList: plantNameList,
    pickerName: 'plant-info',
  });
  useEffect(() => {
    const plant = plantItemList.find(
      (item) => item.plant_name === pickerSelect,
    );
    setSelectPlant((prev) =>
      plant
        ? {
            id: plant.id,
            name: plant.plant_name,
            address: [plant.address1, plant.address2, plant.address3].join(''),
            phone: plant.phone_no,
          }
        : prev,
    );
  }, [pickerSelect, plantItemList]);

  const plantInfoCheck = useMemo(() => {
    return pickerSelect && pickerSelect !== '';
  }, [pickerSelect]);

  return {
    pickerInputID,
    selectPlant,
    plantInfoCheck,
  };
};
